export interface Contact {
  display: string;
  email: string;
  phone: string;
  userId: string;
  identUserId: string;
}
